import { CheckIcon } from '@heroicons/react/20/solid';

import { EmptyTabState } from 'src/shared/components';

interface EmptyUpdatesProps {
  title: string;
  description: string;
}

const EmptyUpdates: React.FC<EmptyUpdatesProps> = ({ title, description }) => {
  return (
    <EmptyTabState icon={CheckIcon} title={title} description={description} />
  );
};

export default EmptyUpdates;
